
  export default {
'button' : { 

 typeTheme :{ 
 'storeBtn' : { 
  'border-radius' : '0',
  'margin-top' : '0'
 
}} 
}
,
'footerContainer' : { 
  commonTheme : {
  'padding-top' : '10px'
  }}

}